/**
 * App bootstrap. Installs error reporting FIRST — before the root element
 * lookup and before `render()` — because the mount itself can throw
 * (`MountElementNotFoundError`), and a reporter installed after `render` would
 * miss exactly the boot failures worth knowing about. Then imports the global
 * stylesheet (design tokens + reset), and mounts `<App/>` into the `#root`
 * node. The service worker is registered manually (not auto-injected) from the
 * composition root (`CompanionSurface`), which wires the phase-0 build-hash
 * update flow onto the shared `Toast` store — see `src/pwa/`.
 */
import { render } from 'solid-js/web';
import { App } from './App.tsx';
import { MountElementNotFoundError } from './errors/index.ts';
import { initErrorReporting } from './observability.ts';
import './styles/app.scss';

initErrorReporting();

const ROOT_SELECTOR = '#root';
const root = document.querySelector<HTMLElement>(ROOT_SELECTOR);
if (!root) throw new MountElementNotFoundError(ROOT_SELECTOR);

render(() => <App />, root);
